
import {
  memo, useMemo, useState
} from 'react';
import { PageProps } from '../../components/types'
import { DisplayMode } from "../../constants/EnumType"
import { WasteReturnMvColumn } from '../../constants/Column'

import DataGrid, { CalculatedColumn, RowsChangeData } from 'react-data-grid'
import {
  Tab 
} from '@headlessui/react'
import DatePicker from 'react-datepicker'
import { SearchField } from '@aws-amplify/ui-react';
import {
  Card
} from '@aws-amplify/ui-react'

import { AiOutlineClose } from 'react-icons/ai'
import { FiPackage } from 'react-icons/fi'
import { HiQueueList } from 'react-icons/hi2'
import { BsCalendarDate, BsClipboardCheck, BsCheck2 } from 'react-icons/bs'

import useWasteReturnMv from '../../hooks/useWasteReturnMv';
import { formatDateFromUnix } from '../../utilities/Format';
import { DgtPdOrderPicklistMovement, WasteRecordStatus } from '../../models';
import PicklistDetailModal from '../../components/PicklistDetailModal';

import { 
  whApproveWasteReturnMovement,
  whRejectWasteReturnMovement
} from '../../states/PicklistAction'
 
export default memo(function WasteReturnPicklist({ title, division, line, from, to, username }: PageProps) {
  const [ keyword, setKeyword ] = useState<string>('')
  const [ displayMode ] = useState<DisplayMode>(DisplayMode.TABLE)
  const [ startDate, setStartDate ] = useState<Date>(from || new Date());
  const [ endDate, setEndDate ] = useState<Date>(to || new Date());
  const [ selectedOrderId, setSelectedOrderId ] = useState<string>('');
  const [ filterIdx, setFilterIdx ] = useState<number>(0)

  const [ wasteReturns, mutateWasteReturn ] = useWasteReturnMv(startDate, endDate, keyword)

  const onChange = (dates: [Date, Date]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const onRowClick = (
    row: DgtPdOrderPicklistMovement,
    column: CalculatedColumn<DgtPdOrderPicklistMovement>) => {
    if (column.key === 'orderId') {
      setSelectedOrderId(row.orderId)
    }
  }

  const onRowsChange = async (rows: DgtPdOrderPicklistMovement[], 
    changedInfo: RowsChangeData<DgtPdOrderPicklistMovement>) => {
    const changedRowIdx = changedInfo.indexes[0]
    if (changedRowIdx < 0) return

    const changedRow = rows[changedRowIdx]

    try {
      if (changedRow.approvedWasteReturnDateTime! > 0) {
        const updated = await whApproveWasteReturnMovement(changedRow, username!)
        mutateWasteReturn(updated)
      } else {
        const updated = await whRejectWasteReturnMovement(changedRow)
        mutateWasteReturn(updated)
      }
    } catch (err) {
      alert('เกิดความผิดพลาด กรุณาตรวจสอบ Internet และลองอีกครั้ง')
    }
  }

  

  const filterLabels = useMemo(() => {
    const allCount = wasteReturns.length
    const approvedCount = wasteReturns.filter(rt => rt.approvedWasteReturnDateTime! > 0 || rt.wasteRecordedStatus === WasteRecordStatus.QC_APPROVED).length
    return [
      { label: 'ทั้งหมด', count: allCount },
      { label: 'รอการตรวจสอบ', count: allCount - approvedCount },
      { label: 'ตรวจสอบแล้ว', count: approvedCount }
    ]
  }, [ wasteReturns ])

  const filteredReturns = useMemo((): readonly DgtPdOrderPicklistMovement[] => {
    if (filterIdx === 1) {
      return wasteReturns.filter(rt => !rt.approvedWasteReturnDateTime && rt.wasteRecordedStatus !== WasteRecordStatus.QC_APPROVED)
    } else if (filterIdx === 2) {
      return wasteReturns.filter(rt => rt.approvedWasteReturnDateTime! > 0 || rt.wasteRecordedStatus === WasteRecordStatus.QC_APPROVED)
    }
    return wasteReturns
  }, [ wasteReturns, filterIdx ]);

  return <div className="page-container">
    {/* Header v2 */}
    <div className='space-y-3 '>
      <h3>{title}</h3>
      <div className='flex flex-col justify-between gap-4 md:flex-row'>
        <div className="relative">
          <span className='absolute inset-y-0 left-0 z-10 flex items-center px-3 text-muted'>
            <BsCalendarDate />
          </span>
          <DatePicker
            className='mr-5 pl-9 input-form-date'
            selected={startDate}
            onChange={onChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            dateFormat="dd/MM/yyyy"
          />
        </div>
        <div>
          <SearchField label="search" placeholder='ค้นหาด้วย PD Order...' onChange={v => setKeyword(v.currentTarget.value)}/>
        </div>
        {/* TODO - Switch display mode */}
        {/* <div className='flex items-center gap-2'>
          <p className={`flex items-center gap-1${displayMode === DisplayMode.TABLE ? ' font-bold text-teal-700' : ' font-extralight text-gray-400'}`}><BiTable />TABLE</p>
          <Switch
            checked={displayMode === DisplayMode.CARD}
            onChange={(checked: boolean) => setDisplayMode(checked ? DisplayMode.CARD : DisplayMode.TABLE)}
            className={`${displayMode === DisplayMode.CARD ? 'bg-red-900' : 'bg-teal-700'}
              relative inline-flex h-[24px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
          >
            <span
              aria-hidden="true"
              className={`${displayMode === DisplayMode.CARD ? 'translate-x-9' : 'translate-x-0'}
                pointer-events-none inline-block h-[20px] w-[34px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
            />
          </Switch>
          <p className={`flex items-center gap-1${displayMode === DisplayMode.CARD ? ' font-bold text-red-900' : ' font-extralight text-gray-400'}`}><BsCardText />CARD</p>
        </div> */}
      </div>
    </div>
    {/* Tab Menu */}
    <Tab.Group
      onChange={setFilterIdx}
      >
      <Tab.List className='flex font-light text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700'>
        {filterLabels.map(filter => 
          <Tab
            key={filter.label}
            className={({ selected }) =>
              `${selected ? 'ttext-[#007bff] border-b-2 border-[#007bff] font-bold':'text-gray-400'} p-3`
            }
          >{filter.label}<span className='p-1 ml-2 text-xs font-bold text-white rounded-full bg-[#007bff]'>{filter.count}</span></Tab>
        )}
      </Tab.List>
    </Tab.Group>
    { displayMode === DisplayMode.TABLE ? 
    <DataGrid className="mt-4" style={{ height: "100%", contain: "none" }}
      columns={WasteReturnMvColumn}
      rows={filteredReturns}
      onRowClick={onRowClick}
      onRowsChange={onRowsChange}
      rowHeight={50}
    /> : <div className='grid grid-cols-1 gap-3 mt-4 md:grid-cols-2 xl:grid-cols-3'>
      {filteredReturns.map(ret => <Card key={ret.id} variation="elevated" borderRadius="medium">
        <div className='w-full space-y-3'>
          <div className='flex items-center justify-between '>
            <h5 className='flex items-center gap-2 font-bold'><BsClipboardCheck />{ret.orderId}</h5>
            {/* TODO - Show Badge when approved - approvedWasteReturnDateTime > 0 */}
            {/* <Badge variation="success"><BsCheck2 />APPROVED</Badge> */}
          </div>
          <h5 className='flex items-center gap-2 font-bold'><FiPackage />{ret.materialCode} - {ret.materialDescription}</h5>
          <div className='flex justify-between'>
            <h6 className='flex items-center gap-3 font-light'><HiQueueList />LOT. {ret.batchLotNo}</h6>
            <h4 className='font-bold'>{ret.returnWasteQty} {ret.materialUnit}</h4>
          </div>
          <div className='flex items-center justify-between '>
            <p className='text-sm italic font-light'>บันทึกเมื่อ : {formatDateFromUnix(ret.recordedDateTime)}</p>
            {/* TODO - Show time */}
            {/* <p className='text-sm italic font-light'>อนุมัติเมื่อ : {formatDateFromUnix(ret.approvedWasteReturnDateTime)}</p> */}
          </div>
          <div className='flex w-full gap-2'>
            <button className='flex-1 gap-1 btn-outline-danger'><AiOutlineClose size={20}/>ปฎิเสธ</button>
            <button className='flex-1 gap-1 btn-success'><BsCheck2 size={20}/>อนุมัติ</button>
          </div>
        </div>
      </Card>)}
    </div>
    }
    <PicklistDetailModal orderId={selectedOrderId} onHide={() => setSelectedOrderId('')}/>
  </div>
})